export default "__VITE_ASSET__C8MeHtsn__"